export const CATEGORIES = [
  'Comedie',
  'Policier',
  'Thriller',
  'Drame',
  'Aventures',
  'Science Fiction',
  'Fantastique',
  'Théatre',
  'Classique',

]

export const QUALITIES = ['2160p', '1080p', '720p', 'DVD', 'HDTV']
export const LANGUAGES = ['FR', 'EN']

/** Map TMDB genre names to collection categories (first match wins). */
export const TMDB_GENRE_MAP = {
  Comedy: 'Comedie',
  Drama: 'Drame',
  Action: 'Aventures/Action',
  Adventure: 'Aventures/Action',
  'Science Fiction': 'Science Fiction',
  Fantasy: 'Fantastique',
  Thriller: 'Thriller',
  Animation: 'Dessins Animés',
  Documentary: 'Documentaire',
  Family: 'Spectacle',
  Music: 'Spectacle',
  Romance: 'Drame',
  Horror: 'Thriller',
  War: 'Aventures/Action',
  Western: 'Aventures/Action',
  'TV Movie': 'Serie',
}

export function categoryFromTmdbGenres(genres = []) {
  for (const genre of genres) {
    const mapped = TMDB_GENRE_MAP[genre.name]
    if (mapped && CATEGORIES.includes(mapped)) return mapped
  }
  return ''
}
